import { lazy, Suspense, useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";

const HomePage = lazy(() => import("./pages/HomePage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
    <div className="text-center" role="status" aria-label="Loading content" aria-live="polite">
      <div
        className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"
        aria-hidden="true"
      />
      <p className="text-muted-foreground">Loading...</p>
    </div>
  </div>
);

function App() {
  const [isValidPath, setIsValidPath] = useState(true);

  useEffect(() => {
    // Check if the current path is the root
    const path = window.location.pathname;
    setIsValidPath(path === "/");
  }, []);

  return (
    <HelmetProvider>
      <Suspense fallback={<LoadingFallback />}>
        {isValidPath ? <HomePage /> : <NotFound />}
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
